/**
 * Test IDs for QA automation.
 */
export const testIds = {
  extensionOperationButtonsRun: "extension-operation-buttons-run",
} as const;
